import { DataSource } from '@angular/cdk/collections';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { cleanStringForComparison } from '../../../core/utilities';
import { cloneDeep } from 'lodash';
import { SortingEnum } from '../enums/sorting-enum';
import { BlsGmbDifference } from '../../../models/locations-models/bls-gmb-difference';
import { BlsGmbDifferencesState } from './bls-gmb-differences-local-store.service';
import { getFullNameForFieldID } from '../location-utils';

export class TableDataSource extends DataSource<BlsGmbDifference> {

  constructor(private blsGmbDifferencesState$: Observable<BlsGmbDifferencesState>) {
    super();
  }

  /**
   * Connect data src
   */
  connect(): Observable<BlsGmbDifference[]> {
    return this.blsGmbDifferencesState$.pipe(
        map((state) => {
          return this.sortByFieldName(state);
        }),
    );
  }


  disconnect() {
  }

  /**
   * Sort table rows by field name
   * @param state
   */
  private sortByFieldName(state: BlsGmbDifferencesState): BlsGmbDifference[] {
    if (!state.sorting) {
      return state.differences;
    }

    // we don't want to mutate state!
    const differencesCopy = cloneDeep(state.differences);

    return differencesCopy.sort((a, b) => {
      const strA = cleanStringForComparison(getFullNameForFieldID(a.fieldId));
      const strB = cleanStringForComparison(getFullNameForFieldID(b.fieldId));

      return (strA > strB ? 1 : -1) *
          // negate if direction isn't 'asc'
          (state.sorting === SortingEnum.ASCENDING ? 1 : -1);
    });
  }
}